import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import swal from 'sweetalert';
import VueChartkick from 'vue-chartkick';
import Chart from 'chart.js';
import FBSignInButton from 'vue-facebook-signin-button'

window.fbAsyncInit = function () {
	FB.init({
		appId: '280701099138021',
		cookie: true, // enable cookies to allow the server to access the session
		xfbml: true, // parse social plugins on this page
		version: 'v2.8' // use graph api version 2.8
	});
};
(function (d, s, id) {
	var js, fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s);
	js.id = id;
	js.src = "//connect.facebook.net/en_US/sdk.js";
	fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

Vue.config.productionTip = false
Vue.use(require('vue-moment'))
Vue.use(VueChartkick, {
	adapter: Chart
})
Vue.use(FBSignInButton)

var app = new Vue({
	router,
	store,
	swal,
	beforeCreate() {
		this.$store.commit('initialiseStore');
	},
	render: h => h(App)
});



Vue.mixin({
	methods: {
		navigate(route) {
			router.push(route);
		},
		reportError(data) {
			console.log(data);
		},
		accessStore(field) {
			return eval("this.$store.getters." + field);
		}
	}
})

router.beforeEach((to, from, next) => {
	if (to.name != "login") {
		if (JSON.parse(localStorage.getItem("store")).user == null || JSON.parse(localStorage.getItem("store")).apiToken == null) {
			next({
				path: "/"
			});
		}
	}
	next();
})

app.$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js